/* eslint-disable prettier/prettier */
/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-vars */
import React, { useState, useContext } from "react";
import styled from "styled-components";
import * as Yup from "yup";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import FormControl from "@mui/material/FormControl";
import { FilledInput, Grid } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import Button from "../../components/Layout/Button";
import Logo from "../../assets/images/Logo.svg";
import LoginBackgroundFront from "../../assets/images/LoginBackgroundFront.png";
import LoginBackground from "../../assets/images/LoginBackground.png";
import { SERVICES } from "../../components/Layout/Services";
import { post } from "../../components/Layout/ApiHandler/apihandler";
import { loginAction } from "../../Config/Redux/actions/authActions";
import { updateMemberIdAction } from "../../Config/Redux/actions/memberActions";
import { ROUTES } from "../../components/Routes";

import { ToastAlertContext } from "../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../contants";
import {
  startSessionTimer,
  clearSessionTimer,
} from "../../Config/sessionManager";

const Background = styled.div`
  background: url(${LoginBackground});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  // padding: 112px 0px;
`;
const Footer = styled.div`
  position: absolute;
  bottom: 5px;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #999;
`;
const MainContainer = styled.div`
  display: flex;
  // border: 1px solid black;
  border-radius: 10px;
  width: 85%;
  // margin: 50px 0
`;
const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50%;
  background: url(${LoginBackgroundFront});
  background-size: 100% 100%;
  // height: 80vh;
`;
const WelcomeText = styled.p`
  color: #eaeaeb;
  text-align: center;
  font-size: 48px;
  font-weight: 700;
  margin: 0 0;
`;
const ContributionText = styled.p`
  color: #fff;
  text-align: center;
  font-size: 40px;
  font-weight: 700;
  margin: 0 0;
`;
const RightContainer = styled.div`
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;
  width: 50%;
  background: #fff;
  // border-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
`;
const LoginText = styled.p`
  color: #00adf8;
  font-size: 48px;
  font-style: normal;
  font-weight: 300;
  margin: 0 0;
  padding: 40px 0 30px 120px;
`;
const LoginName = styled.div`
  padding-left: 120px;
`;
const LoginNameText = styled.p`
  color: #484848;
  // font-family: ITC Avant Garde Gothic Std;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  margin: 0 0;
`;
const LoginPassword = styled.div`
  // padding-left: 120px;
  padding: 25px 0 0 120px;
`;
const BtnContainer = styled.div`
  padding: 50px 0 0 120px;
`;

const NoteContainer = styled.div`
  padding: 40px 100px 50px 120px;
`;

const NoteText = styled.p`
  color: #616060;
  font-size: 14px;
  font-weight: 400;
  margin: 0 0;
  .important-text {
    color: #df5c33;
    font-weight: 700;
  }
`;
const validationSchema = Yup.object().shape({
  memberId: Yup.string().required("Member ID is required"),
  password: Yup.string().required("Password is required"),
});
function Login() {
  const toast = useContext(ToastAlertContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const TITLE = "Login - BSG ContributionAdmin";

  const formik = useFormik({
    initialValues: {
      memberId: "",
      password: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const { memberId, password } = values;
      const url = SERVICES.CONTRIBUTION_LOGIN;

      try {
        const response = await post(url, { memberId, password });
        const xAuthToken = response.headers.get("X-Auth-Token");
        const now = new Date();
        const formattedTime = `${now.getFullYear()}-${String(
          now.getMonth() + 1,
        ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}-${String(
          now.getHours(),
        ).padStart(2, "0")}-${String(now.getMinutes()).padStart(
          2,
          "0",
        )}-${String(now.getSeconds()).padStart(2, "0")}`;
        // console.log(response);
        if (response.ok) {
          localStorage.setItem("X-Auth-Token", xAuthToken);
          localStorage.setItem("LoginTime", formattedTime);
          // sendLoginData(memberId, formattedTime);
          // ✅ Start session timer
          startSessionTimer(
            // 🔴 onLogout handler
            () => {
              clearSessionTimer();
              localStorage.removeItem("X-Auth-Token");
              localStorage.removeItem("LoginTime");
              // toast.show(
              //   "Session expired. Please login again.",
              //   AlertStatus.ERROR,
              // );
              navigate(ROUTES.LOGIN);
            },
            // 🟢 onExtend handler
            () => {
              clearSessionTimer();
              startSessionTimer(
                () => {
                  clearSessionTimer();
                  localStorage.removeItem("X-Auth-Token");
                  localStorage.removeItem("LoginTime");
                  toast.show(
                    "Session expired. Please login again.",
                    AlertStatus.ERROR,
                  );
                  navigate(ROUTES.LOGIN);
                },
                () => {
                  clearSessionTimer();
                  startSessionTimer(onLogout, onExtend);
                },
              );
              toast.show("Session extended", AlertStatus.SUCCESS);
            },
          );
          dispatch(loginAction());
          dispatch(updateMemberIdAction(memberId));
          // toast.show("Login Success", AlertStatus.SUCCESS);
          // navigate(ROUTES.OTP_AUTHENTICATION_PAGE);
          if (xAuthToken !== null) {
            navigate(ROUTES.OTP_AUTHENTICATION_PAGE);
          }
        } else {
          toast.show("Invalid Credentials", AlertStatus.ERROR);
          formik.setFieldError("SubmitError", "Invalid MemberID or Password");
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    },
  });

  const handleForgetPassword = () => {
    navigate(ROUTES.FORGET_PASSWORD);
  };

  const [showPassword, setShowPassword] = useState(false);
  // const handleClickShowPassword = () => setShowPassword((show) => !show);
  // const handleMouseDownPassword = (event) => {
  //   event.preventDefault();
  // };
  const handleClickShowPassword = () => {
    formik.setFieldValue("showPassword", !formik.values.showPassword);
  };
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Background>
        <MainContainer>
          <LeftContainer>
            <img src={Logo} alt="/logo" />
            <WelcomeText>Welcome</WelcomeText>
            <ContributionText>Contribution Admin</ContributionText>
            <span style={{ fontStyle: "italic", color: "white" }}>
              (Access to Chapter Statistics Incharges only)
            </span>
          </LeftContainer>
          <RightContainer>
            <form onSubmit={formik.handleSubmit}>
              <LoginText>Log In</LoginText>
              <LoginName>
                <LoginNameText>Member Id</LoginNameText>
                <TextField
                  id="memberId"
                  name="memberId"
                  type="number"
                  placeholder="Member Id"
                  sx={{
                    width: "70%",
                    "& input": {
                      paddingTop: "7px !important",
                      paddingBottom: "7px !important",
                      "&[type=number]::-webkit-inner-spin-button, &[type=number]::-webkit-outer-spin-button":
                        {
                          "-webkit-appearance": "none",
                          margin: 0,
                        },
                    },
                  }}
                  variant="filled"
                  InputProps={{
                    disableUnderline: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <PersonOutlineIcon />
                      </InputAdornment>
                    ),
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.memberId}
                  error={formik.touched.memberId && formik.errors.memberId}
                />
              </LoginName>
              <LoginPassword>
                <LoginNameText>Password</LoginNameText>
                <FormControl
                  variant="filled"
                  sx={{
                    width: "70%",
                    "& input": {
                      paddingTop: "7px !important",
                      paddingBottom: "7px !important",
                    },
                  }}
                >
                  <FilledInput
                    id="password"
                    name="password"
                    type={formik.values.showPassword ? "text" : "password"}
                    placeholder="Password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                    error={formik.touched.password && formik.errors.password}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={(e) => e.preventDefault()}
                          edge="end"
                        >
                          {formik.values.showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password"
                    disableUnderline
                  />
                  <Grid item sx={{ marginLeft: "auto" }}>
                    {" "}
                    <p
                      style={{
                        cursor: "pointer",
                        color: "#484848",
                        fontWeight: "500",
                        marginTop: "10px",
                        marginBottom: "0px",
                      }}
                      onClick={handleForgetPassword}
                    >
                      Forgot Password?
                    </p>
                  </Grid>
                </FormControl>
              </LoginPassword>
              <BtnContainer>
                <Button type="submit" width="70%">
                  Submit
                </Button>
              </BtnContainer>
            </form>
            <NoteContainer>
              <NoteText>
                <span className="important-text">Important Note: -</span> Please
                do not copy and paste the password from the mail box. Kindly
                type the password. The password is case sensitive.
              </NoteText>
            </NoteContainer>
          </RightContainer>
        </MainContainer>
        <Footer>
          Copyright Bharat Soka Gakkai © 2026. All rights reserved.
        </Footer>
      </Background>
    </>
  );
}
const onLogout = () => {
  // Clear token & session
  localStorage.removeItem("X-Auth-Token");
  localStorage.removeItem("LoginTime");
  const toast = useContext(ToastAlertContext);
  const navigate = useNavigate();
  clearSessionTimer();
  toast.show(
    "Your session has expired. Please log in again.",
    AlertStatus.WARNING,
  );
  navigate(ROUTES.LOGIN); // or ROUTES.HOME, depending on flow
};

const onExtend = () => {
  // Extend session for 30 more minutes
  clearSessionTimer();
  const toast = useContext(ToastAlertContext);
  startSessionTimer(onLogout, onExtend);
  toast.show("Session extended.", AlertStatus.SUCCESS);
};

export default Login;
